// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"af6d32de","539":"6e7e9a15","671":"bc03affd","815":"c83d4fbb","896":"0c21f25e","920":"f7c6236c"}[chunkId] + ".chunk.js";
};